var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 25,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3354 18.9218C28.3938 18.4552 28.4375 17.9812 28.4375 17.5C28.4375 17.0187 28.3938 16.5447 28.3354 16.0781L31.4198 13.6645C31.6969 13.4458 31.7771 13.052 31.5948 12.7312L28.6781 7.67808C28.4958 7.36454 28.1167 7.23329 27.7885 7.36454L24.1573 8.83017C23.4062 8.25413 22.5823 7.76558 21.6927 7.39371L21.1458 3.52913C21.0802 3.18642 20.7812 2.91663 20.4167 2.91663H14.5833C14.2187 2.91663 13.9198 3.18642 13.8615 3.52913L13.3146 7.39371C12.425 7.76558 11.601 8.24683 10.85 8.83017L7.21875 7.36454C6.89062 7.24058 6.51146 7.36454 6.32917 7.67808L3.4125 12.7312C3.23021 13.0448 3.31042 13.4385 3.5875 13.6645L6.66458 16.0781C6.60625 16.5447 6.5625 17.0187 6.5625 17.5C6.5625 17.9812 6.60625 18.4552 6.66458 18.9218L3.5875 21.3354C3.31042 21.5541 3.23021 21.9479 3.4125 22.2687L6.32917 27.3218C6.51146 27.6354 6.89062 27.7666 7.21875 27.6354L10.85 26.1698C11.601 26.7458 12.425 27.2343 13.3146 27.6062L13.8615 31.4708C13.9198 31.8135 14.2187 32.0833 14.5833 32.0833H20.4167C20.7812 32.0833 21.0802 31.8135 21.1385 31.4708L21.6854 27.6062C22.575 27.2343 23.399 26.7531 24.15 26.1698L27.7812 27.6354C28.1094 27.7593 28.4885 27.6354 28.6708 27.3218L31.5875 22.2687C31.7698 21.9552 31.6896 21.5614 31.4125 21.3354L28.3354 18.9218ZM17.5 22.6041C14.6781 22.6041 12.3958 20.3218 12.3958 17.5C12.3958 14.6781 14.6781 12.3958 17.5 12.3958C20.3219 12.3958 22.6042 14.6781 22.6042 17.5C22.6042 20.3218 20.3219 22.6041 17.5 22.6041Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.2a9ccb253a5d1506d9d5357b8e0cada5.svg";
export { ForwardRef as ReactComponent };